import { autoinject, computedFrom, observable } from 'aurelia-framework';
import { DialogController, DialogService } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { SecurityService } from "../../services/security-service";
import { PageMessageService } from "../../services/page-message-service";
import 'jquery';
import 'notify';
import { Guid } from 'guid-typescript';
import { SimpleDialog } from './simple-dialog';
import { UpdateUserModel } from '../../data/typegen/dtos/update-user-model';
import { DisplayValuePair } from '../../data/typegen/dtos/display-value-pair';
import { PromptDialog } from '../../resources/dialogs/prompt-dialog';


@autoinject
export class UpdateUserDialog {
    skipDbUpdate: boolean;
    constructor(
        protected controller: DialogController,
        private busyService: BusyService,
        private dialogService: DialogService,
        private msg: PageMessageService,
        private api: WebApiService) {
    }

    isUserNameLocked = false;
    user: UpdateUserModel;
    roles: Array<any> = [];
    userRoles: Array<any> = [];
    selectedGroupIds: Array<string> = [];
    roleMatcher = (a, b) => a.roleId === b.id;
    canEditEmail = false;
    mills: Array<any> = [];
    groups: Array<DisplayValuePair<string>> = [];
    selectedMills: Array<any> = [];

    async activate(model: { user: UpdateUserModel, skipDbUpdate: boolean, ensureViewRole: boolean }) {
        if (model.user.id) {
            this.busyService.on();
            try {
                const result = await this.api.get("Auth", "GetUser", { aspNetUserId: model.user.id });
                const userInfo = JSON.parse(result.response);
                const unTypedUser = userInfo.user;
                this.selectedGroupIds = userInfo.groupIds;
                unTypedUser.millCodes = unTypedUser.millCodes ? unTypedUser.millCodes.split(',') : [];
                unTypedUser.roles = unTypedUser.roles ? unTypedUser.roles.split(',') : [];
                this.user = unTypedUser;
            } finally {
                this.busyService.off();
            }
        } else {
            this.user = Object.assign(new UpdateUserModel(), model.user);
        }


        // can only edit email for local auth0 accounts.  
        // non-nucor.com emails may need to be edited if the user entered the wrong one during signup, for example.
        if (!this.isSSOUser && (!this.user.auth0UserId || (this.user.auth0UserId.indexOf("auth0|") > -1))) {
            this.canEditEmail = true;
        }

        this.skipDbUpdate = model.skipDbUpdate;
        this.selectedMills = [];
        if (this.user.millCodes.length > 0) {
            this.selectedMills.push(...this.user.millCodes);
        }

        if (this.user.userName) {
            this.isUserNameLocked = true;
        }

        await this.loadRoles();
        this.loadUserRoles(model.ensureViewRole);
        this.loadMills();
        this.loadGroups();
    }

    public async generateChangePasswordLink() {
        this.busyService.on();
        let url = "[url could not be generated]";
        try {
            debugger;
            var params = { EmailAddress: this.user.email };
            var result = await this.api.post("Auth", "GetChangePasswordLink", params);
            url = JSON.parse(result.response)
        }
        finally {
            this.busyService.off();
        }
        await this.dialogService.open(
            {
                viewModel: PromptDialog,
                model: {
                    question: "Below is a link that can be used to change the password for " + this.user.firstName + " " + this.user.lastName,
                    defaultValue: url
                }
            });
    }

    createUserInAuth0() {
        this.dialogService.open({
            viewModel: SimpleDialog,
            model: {
                title: "Enable User For Login",
                icon: "fa-exclamation-triangle",
                message: "This will configure a user in SSO for the user: " + this.user.email + ".  Do you want to continue?\n\nThis cannot be undone.",
                buttons: ["Yes", "No"]
            }
        })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "Yes") {
                        this.busyService.on();
                        this.api.post("Auth", "ConfigureUserForSSO", { id: this.user.id, email: this.user.email, firstName: this.user.firstName, lastName: this.user.lastName, userName: this.user.email, roles: this.userRoles, millCodes: this.user.millCodes }).then((result) => {
                            const answer = JSON.parse(result.response);
                            if (answer) {
                                alert("FIX THIS");
                                //this.user.auth0UserId = answer;
                            }
                        })
                            .finally(() => {
                                this.busyService.off();
                            });
                    }
                }
            });
    }

    loadMills() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                this.mills = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    loadGroups() {
        this.busyService.on();
        return this.api.get("Auth", "GetGroups")
            .then((result) => {
                this.groups = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    loadRoles() {
        this.busyService.on();
        return this.api.get("Auth", "GetRoles")
            .then((result) => {
                this.roles = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    loadUserRoles(ensureViewRole: boolean) {
        this.busyService.on();
        return this.api.get("Auth", "GetUserRoles", { userId: this.user.id })
            .then((result) => {
                this.userRoles = JSON.parse(result.response).map(o => o.roleId);
                if (ensureViewRole) {
                    var viewRole = this.roles.find(o => o.id == "cmp.role.view");
                    if (this.userRoles.indexOf(viewRole.id) == -1) {
                        this.userRoles.push(viewRole.id);
                    }
                }
            })
            .finally(() => this.busyService.off());
    }

    //TODO: This logic is incorrect and should be more diligent in determining the flag, and considering the usage implications.
    // NOTE: Furthermore, a user could start with "%waad" and be SSO for another applicaiton, and username-password for CMP
    @computedFrom("user.userName")
    get isSSOUser(): boolean {
        if (this.user.userName && this.user.userName.toLocaleLowerCase().indexOf("@nucor.com") > -1) {
            return true;
        }
        return false;
    }

    @computedFrom("user.userName")
    get isEmailValid(): boolean {
        var regExp = /[\w-+]+([.][\w]+)?@[\w-+]+([.][a-z]{2,})+/;
        if (regExp.test(this.user.userName)) {
            return true;
        }
        return false;
    }

    async deactivateUser() {
        await this.setUserActiveStatus(false);
    }
    async activateUser() {
        await this.setUserActiveStatus(true);
    }
    private async setUserActiveStatus(isActive: boolean) {
        var params = {
            id: this.user.id,
            active: isActive
        };

        try {
            var responseMessage = await this.api.post("auth", "SetUserActiveStatus", params);
            this.busyService.off();
            this.controller.ok();
        }
        catch (e) {
            this.busyService.off();
            alert("Error occurred while changing user active status: " + (e.errorMessage || e.message || JSON.stringify(e)));
        }
    }

    async save(insertNew: boolean = false) {

        if (insertNew) {
            this.user.id = undefined;
        }

        if (!this.user.id) {
            this.user.id = Guid.create().toString();
        }

        // per Rebecca, users should be able to have more than one mill assigned.
        //if (this.selectedMills.length > 1) {
        //    alert("Cannot select more than one mill.");
        //    return;
        //}

        //ensure that username is in common email address format
        if (!this.isEmailValid) {
            alert("Username should be in the format of an email");
            return;
        }

        //ensure that first name and last name is specified
        if (!this.isSSOUser && (!this.user.firstName || !this.user.lastName)) {
            alert("First name and last name must be specified.");
            return;
        }

        //if (this.user.userName && this.user.userName.toLocaleLowerCase().indexOf("@nucor.com") > -1) {
        //    this.pageMessageService.setErrorMessage("Users with a `nucor.com` email address should use the SSO option to log in a request a user account.");
        //    return;
        //}

        this.busyService.on();

        const millCodes = this.selectedMills;

        var params: UpdateUserModel = {
            auth0UserId: this.user.auth0UserId,
            id: this.user.id,
            email: this.user.email,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            userName: this.user.email,
            combineReports: this.user.combineReports,
            receiveAutomatedCarrierStatusReport: this.user.receiveAutomatedCarrierStatusReport,
            groupIds: this.selectedGroupIds,
            roles: this.userRoles,
            millCodes: this.selectedMills
        };

        if (this.skipDbUpdate) {
            this.busyService.off();
            this.controller.ok(params);
        } else {

            try {
                await this.api.post("auth", "UpdateUser", params);
                this.busyService.off();
                this.controller.ok();
            }
            catch (e) {
                this.busyService.off();
                this.msg.setErrorMessage("Error occurred while updating user account: " + (e.message || e.errorMessage || JSON.stringify(e)));
            }


        }
    }
}